import React from 'react';
import { BrowserRouter, createBrowserRouter, RouterProvider } from 'react-router';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { useTheme } from '@mui/material/styles';
import authService from './services/AuthService';
import { Roles } from '@beable/roster-backend-client-v1';
import PublicApp from './PublicApp';
import { getRouteConfig } from './routeConfig';
import { Box } from '@mui/material';
import { getStyles } from './styles';

library.add(far, fas);

export default function App() {
  const theme = useTheme();
  const styles = getStyles(theme);
  const user = authService.getUser();
  const adminRoles = [Roles.beableadmin, Roles.districtadmin, Roles.itadmin];

  if (!user || (![...adminRoles, Roles.contentloader, Roles.standardscorrelator].includes(user.role))) {
    return (
      <BrowserRouter>
        <PublicApp />
      </BrowserRouter>
    );
  }
  
  const router = createBrowserRouter(getRouteConfig(user.role));

  return (
      <Box sx={styles.root}>
        <Box component='main' sx={styles.content}>
          <Box sx={styles.appBarSpacer} />
          <RouterProvider router={router} />
        </Box>
      </Box>
  );
}
